import { render } from "./VideoPanel.vue?vue&type=template&id=44ec69d6&scoped=true"
import script from "./VideoPanel.vue?vue&type=script&lang=ts"
export * from "./VideoPanel.vue?vue&type=script&lang=ts"

import "./VideoPanel.vue?vue&type=style&index=0&id=44ec69d6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-44ec69d6"

export default script